/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Coaching_Chat_WithInputs */

const en_us2_coaching_chat_with = /** @type {(inputs: Coaching_Chat_WithInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conversation with ${i?.name}`)
};

const pt_br2_coaching_chat_with = /** @type {(inputs: Coaching_Chat_WithInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conversa com ${i?.name}`)
};

const pt_pt2_coaching_chat_with = /** @type {(inputs: Coaching_Chat_WithInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conversa com ${i?.name}`)
};

/** @type {(inputs: Coaching_Chat_WithInputs) => LocalizedString} */
const es_419_coaching_chat_with = en_us2_coaching_chat_with;

/** @type {(inputs: Coaching_Chat_WithInputs) => LocalizedString} */
const fr_fr2_coaching_chat_with = en_us2_coaching_chat_with;

/** @type {(inputs: Coaching_Chat_WithInputs) => LocalizedString} */
const de_de2_coaching_chat_with = en_us2_coaching_chat_with;

/** @type {(inputs: Coaching_Chat_WithInputs) => LocalizedString} */
const it_it2_coaching_chat_with = en_us2_coaching_chat_with;

/**
* | output |
* | --- |
* | "Conversation with {name}" |
*
* @param {Coaching_Chat_WithInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_chat_with = /** @type {((inputs: Coaching_Chat_WithInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Chat_WithInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_chat_with(inputs)
	if (locale === "es-419") return es_419_coaching_chat_with(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_chat_with(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_chat_with(inputs)
	if (locale === "de-DE") return de_de2_coaching_chat_with(inputs)
	if (locale === "it-IT") return it_it2_coaching_chat_with(inputs)
	return en_us2_coaching_chat_with(inputs)
});
export { coaching_chat_with as "coaching.chat_with" }